// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.sortable-ghost{\r\n  opacity: .8;\r\n  color: #fff!important;\r\n  background: #42b983!important;\n}\r\n", ""]);
// Exports
module.exports = exports;
